import useStore from 'base/store'
import {ActionBlock, Loader, AddHexagonIcon} from 'common/components'
import {UserProjectsList, useGetUserProjects, getActiveProjects} from '..'

export default function UserCurrentProjects() {
  const {data: projects} = useGetUserProjects()

  if (!projects) return <Loader />

  const activeProjects = getActiveProjects(projects)

  if (!activeProjects.length) return <CreateProject />

  return <UserProjectsList projects={activeProjects} />
}

const CreateProject = () => {
  const setCreateProjectOpen = useStore((state) => state.setCreateProjectOpen)

  const handleCreateProjectOpen = () => setCreateProjectOpen(true)

  return (
    <ActionBlock
      icon={<AddHexagonIcon />}
      title="New project"
      text="Fill out a small form to get a loan. The confirmation process will take a little time. After that, you will be able to manage your project."
      buttonText="Create a new project"
      onClick={handleCreateProjectOpen}
    />
  )
}
